import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const BitbucketPlain = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M9.47232 10.0545H6.55665L5.76718 5.92995H10.1788L9.47232 10.0545ZM1.45424 1.69999C1.20663 1.69685 1.00321 1.89511 1.00007 2.14272C0.999618 2.16874 1.00141 2.19475 1.00567 2.22032L2.90983 13.7798C2.95872 14.0718 3.21037 14.2865 3.50642 14.2889H12.6414C12.8637 14.2919 13.0546 14.1315 13.09 13.9121L14.9941 2.22256C15.0338 1.9781 14.8676 1.74754 14.6232 1.70806C14.5976 1.7038 14.5716 1.70178 14.5456 1.70223L1.45424 1.69999Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default BitbucketPlain;
